import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const MembershipValidationHome = loadable(() => import('./MembershipHome'), {
  fallback: <LoadingScreen />,
});

export default MembershipValidationHome;
